module.exports = __webpack_public_path__ + "static/media/jackiegreene.8709385d.png";